export default class CounterPageSelection {
  constructor() {
    this._initialize();
  }

  _initialize() {
    // Counter selection through select box on counter page
    const selectElement = document.getElementById("counter-select");
    if (selectElement) {
      selectElement.addEventListener("change", (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        this.setCounterPageCookie(selectedOption.value)
        window.location.href = selectedOption.getAttribute("data-counter-page");
      });
    }

    // Counter selection through main navigation
    const counterPageMenuItems = document.querySelectorAll('a[data-counter-page]');
    if (counterPageMenuItems) {
      counterPageMenuItems.forEach(menuItem => {
        menuItem.addEventListener('click', event => {
          event.preventDefault();
          const selectedCounterPage = event.target.dataset.counterPage;
          this.setCounterPageCookie(selectedCounterPage)
          window.location.href = event.target.getAttribute('href');
        });
      });
    }
  }

  // Source: https://stackoverflow.com/a/15724300
  setCounterPageCookie(counterPageUriPathSegment) {
    document.cookie = `lastSelectedCounterPage=${counterPageUriPathSegment}; path=/; max-age=${60 * 60 * 24 * 365}`;
  }

}
